module.exports = __webpack_public_path__ + "media/Components/fonts/boldPlayfairDisplayitalic-6b43d67d32ea64b9e83371d092541902.ttf";